/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your exact age from your date of birth — in years, months and days, plus totals and the countdown to your next birthday.`)
};

const es_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra tu edad exacta a partir de tu fecha de nacimiento — en años, meses y días, más totales y la cuenta regresiva para tu próximo cumpleaños.`)
};

const de_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie Ihr genaues Alter von Ihrem Geburtsdatum — in Jahren, Monaten und Tagen, plus Summen und den Countdown zu Ihrem nächsten Geburtstag.`)
};

const nl_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind uw exacte leeftijd uit uw geboortedatum — in jaren, maanden en dagen, plus totalen en de aftelling tot uw volgende verjaardag.`)
};

const fr_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez votre âge exact à partir de votre date de naissance — en années, mois et jours, plus les totaux et le compte à rebours jusqu'à votre prochain anniversaire.`)
};

const it_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova la tua età esatta dalla tua data di nascita — in anni, mesi e giorni, più i totali e il conto alla rovescia al tuo prossimo compleanno.`)
};

const pt_br2_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre sua idade exata a partir da sua data de nascimento — em anos, meses e dias, além dos totais e a contagem regressiva para seu próximo aniversário.`)
};

const pt_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a sua idade exata a partir da sua data de nascimento — em anos, meses e dias, mais totalizações e a contagem regressiva para o seu próximo aniversário.`)
};

const ja_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生年月日から正確な年齢を見つけてください - 年、月、日での正確な年齢、総計、および次の誕生日までのカウントダウン。`)
};

const zh_age_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据出生日期计算您的精确年龄——以年、月、日表示，并附带各项总计和下一个生日的倒计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_intro", locale)
	if (locale === "en") return en_age_intro(inputs)
	if (locale === "es") return es_age_intro(inputs)
	if (locale === "de") return de_age_intro(inputs)
	if (locale === "nl") return nl_age_intro(inputs)
	if (locale === "fr") return fr_age_intro(inputs)
	if (locale === "it") return it_age_intro(inputs)
	if (locale === "pt-BR") return pt_br2_age_intro(inputs)
	if (locale === "pt") return pt_age_intro(inputs)
	if (locale === "ja") return ja_age_intro(inputs)
	return zh_age_intro(inputs)
};